var map = {
	"./badrutts-palace.jpg": 94,
	"./chasa-montana.jpg": 95,
	"./chesa-randolina.jpg": 96,
	"./gstaad-palace.jpg": 97,
	"./guarda-val.jpg": 98,
	"./hornberg.jpg": 99,
	"./hotel-ameron.jpg": 100,
	"./hotel-belvedere.jpg": 101,
	"./hotel-bernerhof.jpg": 102,
	"./hotel-de-rougemont.jpg": 103,
	"./hotel-jungfrau.jpg": 104,
	"./hotel-kernen.jpg": 105,
	"./hotel-krone.jpg": 106,
	"./hotel-kulm.jpg": 107,
	"./hotel-resort-riffelalp.jpg": 108,
	"./hotel-schweizerhof.jpg": 109,
	"./hotel-spitzhorn.jpg": 110,
	"./hotel-tschuggen.jpg": 111,
	"./hotel-ultima.jpg": 112,
	"./hotel-valsana.jpg": 113,
	"./hotel-victoria.jpg": 114,
	"./hotel-waldhaus-am-see.jpg": 115,
	"./hotel-zurbriggen.jpg": 116,
	"./le-grand-bellevue.jpg": 117,
	"./lenkerhof.jpg": 118,
	"./rock-resort.jpg": 119,
	"./sporthotel-pontresina.jpg": 120,
	"./suvretta-house.jpg": 121,
	"./the-chedi.jpg": 122,
	"./waldhotel-national-arosa.jpg": 123
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | placeholder */ 31).then(function() {
		var id = map[req];
		if(!(id + 1)) { // check for number or string
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return id;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 63;
module.exports = webpackAsyncContext;